/**
 * Created by anthony on 8/13/14.
 */
var helpCardButtonMessage = angular.module('helpCardButtonMessage', ['helpCardMessage']);
helpCardButtonMessage.directive('helpCardButtonMessage', function() {
    return {
        restrict: 'E',
        scope: { label: '=', helpMsg: '=' },
        templateUrl: 'ism-angular-lib/directives/helpCardButtonMessage/helpCardButtonMessage.html',
        controller: function($scope, $sce)
        {
            $scope.active = false;
            $scope.sce = $sce;
        }
    };
});